/**
 * Compact stats table below the trading chat: Equity · Total Profit · Day P&L ·
 * Latest daily boost credit (from the 08:00 Dubai broadcast).
 */
export default function StatsTable({ account, latestBoost }) {
  const fmt = (n) => Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const equity = account?.equity_usd || 0;
  const seed = account?.seed_capital || 0;
  const profit = Math.max(0, equity - seed);
  const dayPnl = account?.day_pnl || 0;

  const rows = [
    { k: "Equity",        v: `$${fmt(equity)}`,           tone: "gold" },
    { k: "Total profit",  v: `$${fmt(profit)}`,           tone: profit >= 0 ? "buy" : "sell" },
    { k: "Day P&L",       v: `${dayPnl >= 0 ? "+" : "-"}$${fmt(Math.abs(dayPnl))}`, tone: dayPnl >= 0 ? "buy" : "sell" },
    {
      k: "Latest boost",
      v: latestBoost?.bonus != null ? `+$${fmt(latestBoost.bonus)}` : "—",
      hint: latestBoost?.daily_code ? `${latestBoost.daily_code}` : "Next 08:00 Dubai",
      tone: "gold",
    },
  ];

  return (
    <div className="mt-4 border border-white/10 bg-surface" data-testid="stats-table">
      <div className="grid grid-cols-2 gap-px bg-white/[0.03] md:grid-cols-4">
        {rows.map((r) => (
          <div key={r.k} className="bg-surface p-5">
            <p className="text-[10px] uppercase tracking-[0.28em] text-white/40">{r.k}</p>
            <p
              className={`mt-1 font-tabular text-xl ${
                r.tone === "buy" ? "text-[#26A69A]" :
                r.tone === "sell" ? "text-[#EF5350]" :
                "text-gold"
              }`}
            >
              {r.v}
            </p>
            {r.hint && <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-white/35">{r.hint}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
